import Util from '../../util.js';

class Progress extends HTMLElement {

    #template = document.createElement('template');
    $templateMarkup = `
        <progress></progress>
    `;

    static PROGRESS_BAR_COLORS = {
        default: 'default',
        subtle: 'subtle',
        muted: 'muted',
        invert: 'invert',
        disabled: 'disabled',
        info: 'info',
        success: 'success',
        warning: 'warning',
        error: 'error',
        danger: 'danger',
        special: 'special'
    };

    static PROGRESS_THICKNESSES = {
        small: 'small',
        medium: 'medium',
        large: 'large'
    };

    constructor() {
        super();

        this.attachShadow({mode: 'open'});
        this.addStyle = Util.addStyle;
        this.addStyle('/src/styles/neptune.css');
        this.addStyle('/src/components/atoms/progress/progress.css');
        this.#template.innerHTML = this.$templateMarkup;
        this.shadowRoot.appendChild(this.#template.content.cloneNode(true));

        this.addValueToAttribute = Util.addValueToAttribute;
        this.removeValueFromAttribute = Util.removeValueFromAttribute;
    }

    connectedCallback() {
        this.setProgress();
    }

    static get observedAttributes() {
        return ['value', 'max', 'bar-color', 'thickness'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if(oldValue !== newValue && this.isConnected) {
            this.setProgress();
        }
    }

    setProgress() {
        const progressElement = this.shadowRoot.querySelector('progress');
        if (!progressElement) {
            return;
        }
        
        let value = parseFloat(this.getAttribute('value'));
        let max = parseFloat(this.getAttribute('max'));
        let barColor = (this.getAttribute('bar-color')).trim().toLowerCase();
        let thickness = (this.getAttribute('thickness')).trim().toLowerCase();

        this.#validateNumbers(value, max);
        this.#validateAttributeValue(barColor, 'bar-color', Object.values(Progress.PROGRESS_BAR_COLORS));
        this.#validateAttributeValue(thickness, 'thickness', Object.values(Progress.PROGRESS_THICKNESSES));

        if (
            progressElement.getAttribute('value') == value &&
            progressElement.getAttribute('max') == max &&
            progressElement.getAttribute('data-bar-color') === barColor &&
            progressElement.getAttribute('data-thickness') === thickness
        ) {
            return;
        }

        progressElement.setAttribute('max', max);
        progressElement.setAttribute('value', value);
        progressElement.setAttribute('data-bar-color', barColor);
        progressElement.setAttribute('data-thickness', thickness);
    }

    #validateAttributeValue(value, attributeType, validValues) {
        if (!validValues.includes(value)) {
            console.error(`Invalid ${attributeType} "${value}" for <neptune-progress>. Valid values are: ${validValues.join(', ')}.`);
            throw new Error(`Invalid ${attributeType} "${value}" for <neptune-progress>. Valid values are: ${validValues.join(', ')}.`);
        }
    }

    #validateNumbers(value, max) {
        if (!isFinite(value) || value < 0 || value > max) {
            this.failed = true;
            console.error(`Invalid value "${value}" for <neptune-progress>. The valid range is 0 to ${max}.`);
            throw new Error(`Invalid value "${value}" for <neptune-progress>. The valid range is 0 to ${max}.`);
        }
        if(!isFinite(max) || max <= 0) {
            this.failed = true;
            console.error(`Invalid max "${max}" for <neptune-progress>. Max must be a positive number.`);
            throw new Error(`Invalid max "${max}" for <neptune-progress>. Max must be a positive number.`);
        }
    }
}

customElements.define('neptune-progress', Progress);

export default Progress;